import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleDown } from '@fortawesome/free-solid-svg-icons'
import Lightbox from 'yet-another-react-lightbox'
import Captions from 'yet-another-react-lightbox/plugins/captions'
import Zoom from 'yet-another-react-lightbox/plugins/zoom'
import Download from 'yet-another-react-lightbox/plugins/download'
import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/plugins/captions.css'
import { handleDownloadAll, handleDownloadImage } from '../helpers/SurveyComponentsHelper'

const ImageGallery = ({
  imageGallery,
  maxImageInWrapper,
  overflowingImageAnswerAmount,
  showImage,
  currentImageShow,
  filenameForDownloads,
  onImageClick,
  onCloseLightbox,
  imageAnswer
}) => {
  if (imageGallery.length === 0) {
    if (imageAnswer && imageAnswer.length > 0) {
      return (
        <div className="form-group image-wrapper">
          <div className="no-image-component">
            <span className="material-symbols-outlined no-image-icon">broken_image</span>
            <span className="no-image-message">Imágenes no disponibles</span>
          </div>
        </div>
      )
    }
    return null
  }

  const visibleImages =
    overflowingImageAnswerAmount > 1 ? imageGallery.slice(0, maxImageInWrapper) : imageGallery

  return (
    <>
      <div className="form-group image-wrapper">
        {visibleImages.map((link, index) => (
          <div key={index} className="image-component">
            <img onClick={() => onImageClick(index)} src={link} alt={`Image ${index + 1}`} />
            <a
              className="image-download-btn"
              onClick={() => handleDownloadImage(link, `${filenameForDownloads}-${index + 1}`)}
            >
              Descargar
              <FontAwesomeIcon icon={faArrowCircleDown} />
            </a>
          </div>
        ))}
        {imageGallery.length > maxImageInWrapper && overflowingImageAnswerAmount > 1 && (
          <div className="image-component">
            <img
              className="image-blur"
              onClick={() => onImageClick(maxImageInWrapper)}
              src={imageGallery[maxImageInWrapper]}
              alt="Overflow indicator"
            />
            <div
              className="image-number-blur"
              onClick={() => onImageClick(maxImageInWrapper)}
            >{`+ ${overflowingImageAnswerAmount}`}</div>
          </div>
        )}
        {imageAnswer && imageAnswer.length > 0 && imageGallery.length === 0 && (
          <div className="no-image-component">
            <span className="material-symbols-outlined no-image-icon">broken_image</span>
            <span className="no-image-message">Imágenes no disponibles</span>
          </div>
        )}
      </div>

      {imageGallery.length > 1 && (
        <div className="form-group">
          <button
            className="download-all-button"
            onClick={() => handleDownloadAll(filenameForDownloads, imageGallery)}
          >
            <FontAwesomeIcon
              icon={faArrowCircleDown}
              size="lg"
              className="download-all-button-icon"
            />
            Descargar todas las imagenes
          </button>
        </div>
      )}

      <div>
        <Lightbox
          plugins={[Captions, Zoom, Download]}
          styles={{
            container: { backgroundColor: 'rgba(0, 0, 0, .8)' },
            captionsDescriptionContainer: {
              display: 'flex',
              justifyContent: 'center'
            }
          }}
          open={showImage}
          close={onCloseLightbox}
          animation={{ swipe: 0 }}
          index={currentImageShow}
          zoom={{ scrollToZoom: true }}
          slides={imageGallery.map((link, index) => ({
            src: link,
            description: 'Haga doble clic en la imagen para aumentar/disminuir el zoom.',
            download: { url: link, filename: `${filenameForDownloads}-${index + 1}` }
          }))}
        />
      </div>
    </>
  )
}

export default ImageGallery
